export default "__VITE_ASSET__C_e0rsWB__"